module.exports = __webpack_public_path__ + "static/cateau4-422fea9375367b6e26c3994a07358fad.webp";